'use client';
 
import { addDataLayer } from '@/helpers/dataLayer';
import { Box, Button } from '@dxp-feed/ui';
import Link from 'next/link';
 
interface CTA {
  link?: string;
  target?: string;
  ariaLabel?: string;
  className?: string;
  children?: React.ReactNode;
  datalayerobj?: Record<string, any>;
  border?: boolean
}
 
 
export default function Cta({
  link,
  target,
  ariaLabel,
  className,
  children,
  datalayerobj,
  border = true
}: CTA) {
  return border ? (
    <Button
      variant="primary"
      asChild
      onClick={() => {
        if (datalayerobj) {
          addDataLayer({ ...datalayerobj, page_title: document.title, });
        }
      }}
    >
      <Link
        href={link ?? '#'}
        target={target}
        className={className}
        aria-label={ariaLabel}
      >
        {children}
      </Link>
    </Button>
  ) : (
    <Box
      onClick={() => {
        if (datalayerobj) {
          addDataLayer({ ...datalayerobj, page_title: document.title, });
        }
      }}
    >
      <Link
        href={link ?? '#'}
        target={target}
        className={className}
        aria-label={ariaLabel}
      >
        {children}
      </Link>
    </Box>
  )
}
 
 